import { atom } from 'jotai';

export const confirmNavigationAtom = atom<boolean>(false);
